export default "__VITE_ASSET__BZ6lMdHy__"